import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Paper, Grid, Typography, Tooltip } from "@mui/material";

import {
  MdVerified,
  MdDoorSliding,
  MdOutlineVerified,
  MdOutlineDoorSliding,
  MdOutlineKeyboardAlt,
} from "react-icons/md";
import { IoIosNotifications, IoMdNotificationsOutline } from "react-icons/io";
import KeyboardAltRoundedIcon from "@mui/icons-material/KeyboardAltRounded";

import { styled } from "@mui/material/styles";
import pages from "../../../constants/pages";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Styled Components
const TabButton = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  font-size: 7.5px;
  font-family: "Open Sans, sans-serif";
  font-weight: 400;
  align-items: center;
`;

const OuterBox = styled(Box)`
  box-sizing: border-box;
  min-height: 10vh;
`;

const BoxPaper = styled(Paper)`
  width: 50vw;
  margin: 0 auto;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(20px);
  display: flex;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 8px;
  border-radius: 20px;
  @media (max-width: 900px) {
    width: 90%;
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1300;
  }
`;

const TabItem = ({
  title,
  route,
  selectedRoute,
  navigate,
  IconActive,
  IconInactive,
}) => {
  const isSelected = selectedRoute === route;

  const handleClick = () => {
    if (!isSelected) navigate(route);
  };

  return (
    <Grid
      item
      container
      justifyContent={"center"}
      xs={2.4}
      onClick={handleClick}
      sx={{
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        borderRadius: "14px",
        background: isSelected
          ? "linear-gradient(135deg, #6366f1, #a855f7)"
          : "transparent",
        cursor: "pointer",
        "&:hover": {
          background: isSelected
            ? "linear-gradient(135deg, #4f46e5, #9333ea)"
            : "rgba(255, 255, 255, 0.05)",
        },
      }}
    >
      <Tooltip title={title}>
        <TabButton>
          {isSelected ? (
            <IconActive style={{ fontSize: "22px", color: "white" }} />
          ) : (
            <IconInactive style={{ fontSize: "22px", color: "#94a3b8" }} />
          )}
          <Typography
            variant="body1"
            sx={{
              color: isSelected ? "white" : "#94a3b8",
              fontSize: "12px",
              fontWeight: 600,
              mt: 0.5,
              display: { xs: "none", sm: "block" },
            }}
          >
            {title}
          </Typography>
        </TabButton>
      </Tooltip>
    </Grid>
  );
};

export default function DashboardFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedRoute, setSelectedRoute] = useState(location.pathname);

  useEffect(() => {
    setSelectedRoute(location.pathname);
  }, [location]);

  function stopCamera() {
    const stream = document.querySelector("video")?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      document.querySelector("video").srcObject = null;
    }
  }

  const handleNavigation = (route) => {
    if (selectedRoute !== route) {
      stopCamera();
      navigate(route);
    }
  };

  return (
    <OuterBox>
      <BoxPaper>
        <TabItem
          title="Auto"
          route={pages.MainGateEntryWithBackCamera.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdDoorSliding}
          IconInactive={MdOutlineDoorSliding}
        />
        <TabItem
          title="Manual"
          route={pages.ManualEntry.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={KeyboardAltRoundedIcon}
          IconInactive={MdOutlineKeyboardAlt}
        />
        <TabItem
          title="Resend"
          route={pages.ResendNotification.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={IoIosNotifications}
          IconInactive={IoMdNotificationsOutline}
        />
        <TabItem
          title="Verify"
          route={pages.ManualVerification.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdVerified}
          IconInactive={MdOutlineVerified}
        />

        {/* <TabItem
          title="Booking"
          route={pages.AddBooking.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdVerified}
          IconInactive={MdOutlineVerified}
        /> */}

        <TabItem
          title="Booking Stats"
          route={pages.BookingStats.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdVerified}
          IconInactive={MdOutlineVerified}
        />
      </BoxPaper>
    </OuterBox>
  );
}
